function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_21503_13407)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_21503_13407)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.25 3.1875H9.25C9.10082 3.1875 8.95774 3.24676 8.85225 3.35225C8.74676 3.45774 8.6875 3.60082 8.6875 3.75V7.6875H4.75C4.60082 7.6875 4.45774 7.74676 4.35225 7.85225C4.24676 7.95774 4.1875 8.10082 4.1875 8.25V20.25C4.1875 20.3992 4.24676 20.5423 4.35225 20.6477C4.45774 20.7532 4.60082 20.8125 4.75 20.8125H16.75C16.8992 20.8125 17.0423 20.7532 17.1477 20.6477C17.2532 20.5423 17.3125 20.3992 17.3125 20.25V16.3125H21.25C21.3992 16.3125 21.5423 16.2532 21.6477 16.1477C21.7532 16.0423 21.8125 15.8992 21.8125 15.75V3.75C21.8125 3.60082 21.7532 3.45774 21.6477 3.35225C21.5423 3.24676 21.3992 3.1875 21.25 3.1875ZM16.1875 19.6875H5.3125V8.8125H16.1875V19.6875ZM20.6875 15.1875H17.3125V8.25C17.3125 8.10082 17.2532 7.95774 17.1477 7.85225C17.0423 7.74676 16.8992 7.6875 16.75 7.6875H9.8125V4.3125H20.6875V15.1875Z",
  fill: "#707070"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_21503_13407"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_21503_13407"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "white"
})));

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.4fafc4fb.svg";
export { ForwardRef as ReactComponent };